enum EventActionTypes {
	CREATE_EVENT = "CREATE_EVENT",
	GET_EVENT = "GET_EVENT",
	GET_ALL_EVENTS = "GET_ALL_EVENTS",
	SET_EVENT_ID = "SET_EVENT_ID",
	SET_EVENT_ERROR = "SET_EVENT_ERROR",
	GET_DELETED_EVENTS = "GET_DELETED_EVENTS",
	UPDATE_EVENT = "UPDATE_EVENT",
	DELETE_EVENT = "DELETE_EVENT",
}

export default EventActionTypes;
